export function XML_AddSingle(x, cmd, xmlCanvas) {
  var s = xmlCanvas.GetStream();
  xmlCanvas.OutputSimpleElement(cmd, x, s);
}
